import React, { useState, useEffect } from 'react';
import TastoSelezionaTab from '../logistica/AreaOrdiniComponenti/OrdineComponenti/TastoSelezionaTab';
import stilePulsanti from '../interfaccia/stilePulsanti';
import Tabdati from './tabsProdotto/Tabdati';
import TabPrezzi from './tabsProdotto/TabPrezzi';
import TabGiacenze from './tabsProdotto/TabGiacenze';

function ConsultazioneVistaProdotto({prodotto}) {

    const datiProd = prodotto[0]
    const [schermata,setSchermata] = useState("giacenze")

    const {
        vociMenuTabs,
        vociMenuTabsSelezionata,
    } = stilePulsanti

    return(
        <div className='ma3 br3 sfondoBiancoTema pa3'>
            <div className='f4 ttu'>{datiProd.codVS}</div>
            <div className='f4 b ttu'>{datiProd.nome}</div>
            <div className='flex justify-center mt3'>
            <TastoSelezionaTab
                        idTasto="giacenze"
                        onClickTasto={() => setSchermata("giacenze")}
                        tab={schermata}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata+" pr2"}
                        vociMenuTabs={vociMenuTabs+" colAltScuro pr2"}
                        icona="inventory_2"
                        testo={false}
                        colorIcon=" "
            />
            <TastoSelezionaTab
                        idTasto="prezzi"
                        onClickTasto={() => setSchermata("prezzi")}
                        tab={schermata}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata+" pr2"}
                        vociMenuTabs={vociMenuTabs+" colAltScuro pr2"}
                        icona="sell"
                        testo={false}
                        colorIcon=" "
            />
            <TastoSelezionaTab
                        idTasto="anagrafica"
                        onClickTasto={() => setSchermata("anagrafica")}
                        tab={schermata}
                        vociMenuTabsSelezionata={vociMenuTabsSelezionata+" pr2"}
                        vociMenuTabs={vociMenuTabs+" colAltScuro pr2"}
                        icona="description"
                        testo={false}
                        colorIcon=" "
            />
            </div>
            {schermata === "giacenze" && <TabGiacenze prodotto={prodotto} />}
            {schermata === "prezzi" && <TabPrezzi prodotto={prodotto} />}
            {schermata === "anagrafica" && <Tabdati prodotto={prodotto} />}
            {/* {prodotto && <pre>{JSON.stringify(prodotto, null, 2)}</pre>} */}
        </div>
    )
}

export default ConsultazioneVistaProdotto;